export {
  quotaDialogI18n,
  getQuotaDialogI18n,
  type QuotaDialogI18nConfig,
  type SupportedLang
} from './quota-dialog';
